//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

// state
const agentsListSelector = (state: RootState) => state.admin.agents.list;
const agentsListDataSelector = (state: RootState) => state.admin.agents.list.data;
const agentsListErrorSelector = (state: RootState) => state.admin.agents.list.error;
const agentsListFetchingSelector = (state: RootState) => state.admin.agents.list.isFetching;

//selectors
export const selectList = createSelector(agentsListSelector, (list) => list);
export const selectListData = createSelector(agentsListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectListDataColumnsSort = createSelector(agentsListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectListError = createSelector(agentsListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(agentsListFetchingSelector, (isFetching) => isFetching);


const agentsFullListSelector = (state: RootState) => state.admin.agents.fullList;
const agentsFullListDataSelector = (state: RootState) => state.admin.agents.fullList.data;
const agentsFullListErrorSelector = (state: RootState) => state.admin.agents.fullList.error;
const agentsFullListFetchingSelector = (state: RootState) => state.admin.agents.fullList.isFetching;

//selectors
export const selectFullList = createSelector(agentsFullListSelector, (list) => list);
export const selectFullListData = createSelector(agentsFullListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullListDataColumnsSort = createSelector(agentsFullListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectFullListError = createSelector(agentsFullListErrorSelector, (error) => error);
export const selectFullListIsFetching = createSelector(agentsFullListFetchingSelector, (isFetching) => isFetching);


//Brands List
const agentsBrandsListDataSelector = (state: RootState) => state.admin.agents.brandsList.data;
const agentsBrandsListErrorSelector = (state: RootState) => state.admin.agents.brandsList.error;
const agentsBrandsListFetchingSelector = (state: RootState) => state.admin.agents.brandsList.isFetching;

export const selectAgentsBrandsListData = createSelector(agentsBrandsListDataSelector, (data) => {
  if (!!data && !!data.hasOwnProperty('list')) {
    // @ts-ignore
    return data?.list;
  } else {
    return data;
  }
});
export const selectAgentsBrandsListError = createSelector(agentsBrandsListErrorSelector, (error) => error);
export const selectAgentsBrandsListIsFetching = createSelector(agentsBrandsListFetchingSelector, (isFetching) => isFetching);


//Wallets List
const agentsWalletsDataSelector = (state: RootState) => state.admin.agents.wallets.data;
const agentsWalletsErrorSelector = (state: RootState) => state.admin.agents.wallets.error;
const agentsWalletsFetchingSelector = (state: RootState) => state.admin.agents.wallets.isFetching;

export const selectWalletsData = createSelector(agentsWalletsDataSelector, (data) => data);
export const selectWalletsError = createSelector(agentsWalletsErrorSelector, (error) => error);
export const selectWalletsIsFetching = createSelector(agentsWalletsFetchingSelector, (isFetching) => isFetching);

//Wallets List
const agentsCreateWalletsDataSelector = (state: RootState) => state.admin.agents.createWallets.data;
const agentsCreateWalletsErrorSelector = (state: RootState) => state.admin.agents.createWallets.error;
const agentsCreateWalletsFetchingSelector = (state: RootState) => state.admin.agents.createWallets.isFetching;

export const selectCreateWalletsData = createSelector(agentsCreateWalletsDataSelector, (data) => data);
export const selectCreateWalletsError = createSelector(agentsCreateWalletsErrorSelector, (error) => error);
export const selectCreateWalletsIsFetching = createSelector(agentsCreateWalletsFetchingSelector, (isFetching) => isFetching);


//Agent Options
const agentsDescendantAgentsDataSelector = (state: RootState) => state.admin.agents.descendantAgents.data;
const agentsDescendantAgentsErrorSelector = (state: RootState) => state.admin.agents.descendantAgents.error;
const agentsDescendantAgentsFetchingSelector = (state: RootState) => state.admin.agents.descendantAgents.isFetching;

export const selectDescendantAgentsData = createSelector(agentsDescendantAgentsDataSelector, (data) => data);
export const selectDescendantAgentsError = createSelector(agentsDescendantAgentsErrorSelector, (error) => error);
export const selectDescendantAgentsIsFetching = createSelector(agentsDescendantAgentsFetchingSelector, (isFetching) => isFetching);

//To Agent Options
const agentsToDescendantAgentsDataSelector = (state: RootState) => state.admin.agents.toDescendantAgents.data;
const agentsToDescendantAgentsErrorSelector = (state: RootState) => state.admin.agents.toDescendantAgents.error;
const agentsToDescendantAgentsFetchingSelector = (state: RootState) => state.admin.agents.toDescendantAgents.isFetching;

export const selectToDescendantAgentsData = createSelector(agentsToDescendantAgentsDataSelector, (data) => data);
export const selectToDescendantAgentsError = createSelector(agentsToDescendantAgentsErrorSelector, (error) => error);
export const selectToDescendantAgentsIsFetching = createSelector(agentsToDescendantAgentsFetchingSelector, (isFetching) => isFetching);

//Full Agent Options
const agentsFullAgentsOptionsDataSelector = (state: RootState) => state.admin.agents.fullAgentsOptions.data;
const agentsFullAgentsOptionsErrorSelector = (state: RootState) => state.admin.agents.fullAgentsOptions.error;
const agentsFullAgentsOptionsFetchingSelector = (state: RootState) => state.admin.agents.fullAgentsOptions.isFetching;

export const selectFullAgentsOptionsData = createSelector(agentsFullAgentsOptionsDataSelector, (data) => data);
export const selectFullAgentsOptionsError = createSelector(agentsFullAgentsOptionsErrorSelector, (error) => error);
export const selectFullAgentsOptionsIsFetching = createSelector(agentsFullAgentsOptionsFetchingSelector, (isFetching) => isFetching);


//Full Tr Agent Options
const agentsFullTrAgentsOptionsDataSelector = (state: RootState) => state.admin.agents.fullTrAgentsOptions.data;
const agentsFullTrAgentsOptionsErrorSelector = (state: RootState) => state.admin.agents.fullTrAgentsOptions.error;
const agentsFullTrAgentsOptionsFetchingSelector = (state: RootState) => state.admin.agents.fullTrAgentsOptions.isFetching;

export const selectFullTrAgentsOptionsData = createSelector(agentsFullTrAgentsOptionsDataSelector, (data) => data);
export const selectFullTrAgentsOptionsError = createSelector(agentsFullTrAgentsOptionsErrorSelector, (error) => error);
export const selectFullTrAgentsOptionsIsFetching = createSelector(agentsFullTrAgentsOptionsFetchingSelector, (isFetching) => isFetching);


//Agent Roles
const agentsRolesDataSelector = (state: RootState) => state.admin.agents.agentRoles.data;
const agentsRolesErrorSelector = (state: RootState) => state.admin.agents.agentRoles.error;
const agentsRolesFetchingSelector = (state: RootState) => state.admin.agents.agentRoles.isFetching;

export const selectAgentsRolesData = createSelector(agentsRolesDataSelector, (data) => data);
export const selectAgentsRolesError = createSelector(agentsRolesErrorSelector, (error) => error);
export const selectAgentsRolesIsFetching = createSelector(agentsRolesFetchingSelector, (isFetching) => isFetching);

//WalletIdentities
const agentsWalletIdentitiesDataSelector = (state: RootState) => state.admin.agents.walletIdentities.data;
const agentsWalletIdentitiesErrorSelector = (state: RootState) => state.admin.agents.walletIdentities.error;
const agentsWalletIdentitiesFetchingSelector = (state: RootState) => state.admin.agents.walletIdentities.isFetching;

export const selectWalletIdentitiesData = createSelector(agentsWalletIdentitiesDataSelector, (data) => data);
export const selectWalletIdentitiesError = createSelector(agentsWalletIdentitiesErrorSelector, (error) => error);
export const selectWalletIdentitiesIsFetching = createSelector(agentsWalletIdentitiesFetchingSelector, (isFetching) => isFetching);

//CreateAgent
const agentsCreateAgentDataSelector = (state: RootState) => state.admin.agents.createAgent.data;
const agentsCreateAgentErrorSelector = (state: RootState) => state.admin.agents.createAgent.error;
const agentsCreateAgentFetchingSelector = (state: RootState) => state.admin.agents.createAgent.isFetching;

export const selectCreateAgentData = createSelector(agentsCreateAgentDataSelector, (data) => data);
export const selectCreateAgentError = createSelector(agentsCreateAgentErrorSelector, (error) => error);
export const selectCreateAgentIsFetching = createSelector(agentsCreateAgentFetchingSelector, (isFetching) => isFetching);

//DetailsListRow
const agentsDetailsAgentDataSelector = (state: RootState) => state.admin.agents.details.data;
const agentsDetailsAgentErrorSelector = (state: RootState) => state.admin.agents.details.error;
const agentsDetailsAgentFetchingSelector = (state: RootState) => state.admin.agents.details.isFetching;

export const selectDetailsListAgentData = createSelector(agentsDetailsAgentDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }
      if (item.name === 'username') {
        return { ...item, type: 'shortUsername' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectDetailsListAgentError = createSelector(agentsDetailsAgentErrorSelector, (error) => error);
export const selectDetailsListAgentIsFetching = createSelector(agentsDetailsAgentFetchingSelector, (isFetching) => isFetching);

//FullDetailsListRow
const agentsFullDetailsAgentDataSelector = (state: RootState) => state.admin.agents.fullDetails.data;
const agentsFullDetailsAgentErrorSelector = (state: RootState) => state.admin.agents.fullDetails.error;
const agentsFullDetailsAgentFetchingSelector = (state: RootState) => state.admin.agents.fullDetails.isFetching;

export const selectFullDetailsListAgentData = createSelector(agentsFullDetailsAgentDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }
      if (item.name === 'username') {
        return { ...item, type: 'shortUsername' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullDetailsListAgentError = createSelector(agentsFullDetailsAgentErrorSelector, (error) => error);
export const selectFullDetailsListAgentIsFetching = createSelector(agentsFullDetailsAgentFetchingSelector, (isFetching) => isFetching);

//Enable Wallet
const agentsEnableWalletDataSelector = (state: RootState) => state.admin.agents.enableWallet.data;
const agentsEnableWalletErrorSelector = (state: RootState) => state.admin.agents.enableWallet.error;
const agentsEnableWalletFetchingSelector = (state: RootState) => state.admin.agents.enableWallet.isFetching;

export const selectEnableWalletData = createSelector(agentsEnableWalletDataSelector, (data) => data);
export const selectEnableWalletError = createSelector(agentsEnableWalletErrorSelector, (error) => error);
export const selectEnableWalletIsFetching = createSelector(agentsEnableWalletFetchingSelector, (isFetching) => isFetching);


//Enable Wallet
const agentsDisableWalletDataSelector = (state: RootState) => state.admin.agents.disableWallet.data;
const agentsDisableWalletErrorSelector = (state: RootState) => state.admin.agents.disableWallet.error;
const agentsDisableWalletFetchingSelector = (state: RootState) => state.admin.agents.disableWallet.isFetching;

export const selectDisableWalletData = createSelector(agentsDisableWalletDataSelector, (data) => data);
export const selectDisableWalletError = createSelector(agentsDisableWalletErrorSelector, (error) => error);
export const selectDisableWalletIsFetching = createSelector(agentsDisableWalletFetchingSelector, (isFetching) => isFetching);

//Add Wallet
const agentsAddWalletDataSelector = (state: RootState) => state.admin.agents.addWallet.data;
const agentsAddWalletErrorSelector = (state: RootState) => state.admin.agents.addWallet.error;
const agentsAddWalletFetchingSelector = (state: RootState) => state.admin.agents.addWallet.isFetching;

export const selectAddWalletData = createSelector(agentsAddWalletDataSelector, (data) => data);
export const selectAddWalletError = createSelector(agentsAddWalletErrorSelector, (error) => error);
export const selectAddWalletIsFetching = createSelector(agentsAddWalletFetchingSelector, (isFetching) => isFetching);

//Add Agent Wallet
const agentsAddAgentWalletDataSelector = (state: RootState) => state.admin.agents.addAgentWallet.data;
const agentsAddAgentWalletErrorSelector = (state: RootState) => state.admin.agents.addAgentWallet.error;
const agentsAddAgentWalletFetchingSelector = (state: RootState) => state.admin.agents.addAgentWallet.isFetching;

export const selectAddAgentWalletData = createSelector(agentsAddAgentWalletDataSelector, (data) => data);
export const selectAddAgentWalletError = createSelector(agentsAddAgentWalletErrorSelector, (error) => error);
export const selectAddAgentWalletIsFetching = createSelector(agentsAddAgentWalletFetchingSelector, (isFetching) => isFetching);

//Agent Balance
const agentsAgentBalanceDataSelector = (state: RootState) => state.admin.agents.agentBalance.data;
const agentsAgentBalanceErrorSelector = (state: RootState) => state.admin.agents.agentBalance.error;
const agentsAgentBalanceFetchingSelector = (state: RootState) => state.admin.agents.agentBalance.isFetching;

export const selectAgentBalanceData = createSelector(agentsAgentBalanceDataSelector, (data) => data);
export const selectAgentBalanceError = createSelector(agentsAgentBalanceErrorSelector, (error) => error);
export const selectAgentBalanceIsFetching = createSelector(agentsAgentBalanceFetchingSelector, (isFetching) => isFetching);
//PlayerList
const agentsPlayerListDataSelector = (state: RootState) => state.admin.agents.playerList.data;
const agentsPlayerListErrorSelector = (state: RootState) => state.admin.agents.playerList.error;
const agentsPlayerListFetchingSelector = (state: RootState) => state.admin.agents.playerList.isFetching;

export const selectPlayerListData = createSelector(agentsPlayerListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectPlayerListDataColumnsSort = createSelector(agentsPlayerListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectPlayerListError = createSelector(agentsPlayerListErrorSelector, (error) => error);
export const selectPlayerListIsFetching = createSelector(agentsPlayerListFetchingSelector, (isFetching) => isFetching);

//PlayerList
const agentsFullPlayerListDataSelector = (state: RootState) => state.admin.agents.fullPlayerList.data;
const agentsFullPlayerListErrorSelector = (state: RootState) => state.admin.agents.fullPlayerList.error;
const agentsFullPlayerListFetchingSelector = (state: RootState) => state.admin.agents.fullPlayerList.isFetching;

export const selectFullPlayerListData = createSelector(agentsFullPlayerListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullPlayerListDataColumnsSort = createSelector(agentsFullPlayerListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectFullPlayerListError = createSelector(agentsFullPlayerListErrorSelector, (error) => error);
export const selectFullPlayerListIsFetching = createSelector(agentsFullPlayerListFetchingSelector, (isFetching) => isFetching);

//Player Balance
const agentsPlayerBalanceDataSelector = (state: RootState) => state.admin.agents.playerBalance.data;
const agentsPlayerBalanceErrorSelector = (state: RootState) => state.admin.agents.playerBalance.error;
const agentsPlayerBalanceFetchingSelector = (state: RootState) => state.admin.agents.playerBalance.isFetching;

export const selectPlayerBalanceData = createSelector(agentsPlayerBalanceDataSelector, (data) => data);
export const selectPlayerBalanceError = createSelector(agentsPlayerBalanceErrorSelector, (error) => error);
export const selectPlayerBalanceIsFetching = createSelector(agentsPlayerBalanceFetchingSelector, (isFetching) => isFetching);

//PlayerList Details
const agentsPlayerListDetailsDataSelector = (state: RootState) => state.admin.agents.playerDetails.data;
const agentsPlayerListDetailsErrorSelector = (state: RootState) => state.admin.agents.playerDetails.error;
const agentsPlayerListDetailsFetchingSelector = (state: RootState) => state.admin.agents.playerDetails.isFetching;

export const selectPlayerListDetailsData = createSelector(agentsPlayerListDetailsDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectPlayerDetailsListError = createSelector(agentsPlayerListDetailsErrorSelector, (error) => error);
export const selectPlayerListDetailsIsFetching = createSelector(agentsPlayerListDetailsFetchingSelector, (isFetching) => isFetching);

//FullPlayerList Details
const agentsFullPlayerListDetailsDataSelector = (state: RootState) => state.admin.agents.fullPlayerDetails.data;
const agentsFullPlayerListDetailsErrorSelector = (state: RootState) => state.admin.agents.fullPlayerDetails.error;
const agentsFullPlayerListDetailsFetchingSelector = (state: RootState) => state.admin.agents.fullPlayerDetails.isFetching;

export const selectFullPlayerListDetailsData = createSelector(agentsFullPlayerListDetailsDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectFullPlayerDetailsListError = createSelector(agentsFullPlayerListDetailsErrorSelector, (error) => error);
export const selectFullPlayerListDetailsIsFetching = createSelector(agentsFullPlayerListDetailsFetchingSelector, (isFetching) => isFetching);

//transferToAgent
const agentsTransferToAgentDataSelector = (state: RootState) => state.admin.agents.transferToAgent.data;
const agentsTransferToAgentErrorSelector = (state: RootState) => state.admin.agents.transferToAgent.error;
const agentsTransferToAgentFetchingSelector = (state: RootState) => state.admin.agents.transferToAgent.isFetching;

export const selectTransferToAgentData = createSelector(agentsTransferToAgentDataSelector, (data) => data);
export const selectTransferToAgentError = createSelector(agentsTransferToAgentErrorSelector, (error) => error);
export const selectTransferToAgentIsFetching = createSelector(agentsTransferToAgentFetchingSelector, (isFetching) => isFetching);

//transferAllToAgent
const agentsTransferAllToAgentDataSelector = (state: RootState) => state.admin.agents.transferAllToAgent.data;
const agentsTransferAllToAgentErrorSelector = (state: RootState) => state.admin.agents.transferAllToAgent.error;
const agentsTransferAllToAgentFetchingSelector = (state: RootState) => state.admin.agents.transferAllToAgent.isFetching;

export const selectTransferAllToAgentData = createSelector(agentsTransferAllToAgentDataSelector, (data) => data);
export const selectTransferAllToAgentError = createSelector(agentsTransferAllToAgentErrorSelector, (error) => error);
export const selectTransferAllToAgentIsFetching = createSelector(agentsTransferAllToAgentFetchingSelector, (isFetching) => isFetching);

//Players Options
const agentsPlayersOptionsDataSelector = (state: RootState) => state.admin.agents.playersOptions.data;
const agentsPlayersOptionsErrorSelector = (state: RootState) => state.admin.agents.playersOptions.error;
const agentsPlayersOptionsFetchingSelector = (state: RootState) => state.admin.agents.playersOptions.isFetching;

export const selectPlayersOptionsData = createSelector(agentsPlayersOptionsDataSelector, (data) => data);
export const selectPlayersOptionsError = createSelector(agentsPlayersOptionsErrorSelector, (error) => error);
export const selectPlayersOptionsIsFetching = createSelector(agentsPlayersOptionsFetchingSelector, (isFetching) => isFetching);

//Players WalletIdentities
const agentsPlayerWalletIdentitiesDataSelector = (state: RootState) => state.admin.agents.playerWalletIdentities.data;
const agentsPlayerWalletIdentitiesErrorSelector = (state: RootState) => state.admin.agents.playerWalletIdentities.error;
const agentsPlayerWalletIdentitiesFetchingSelector = (state: RootState) => state.admin.agents.playerWalletIdentities.isFetching;

export const selectPlayerWalletIdentitiesData = createSelector(agentsPlayerWalletIdentitiesDataSelector, (data) => data);
export const selectPlayerWalletIdentitiesError = createSelector(agentsPlayerWalletIdentitiesErrorSelector, (error) => error);
export const selectPlayerWalletIdentitiesIsFetching = createSelector(agentsPlayerWalletIdentitiesFetchingSelector, (isFetching) => isFetching);

//transferToPlayer
const agentsTransferToPlayerDataSelector = (state: RootState) => state.admin.agents.transferToPlayer.data;
const agentsTransferToPlayerErrorSelector = (state: RootState) => state.admin.agents.transferToPlayer.error;
const agentsTransferToPlayerFetchingSelector = (state: RootState) => state.admin.agents.transferToPlayer.isFetching;

export const selectTransferToPlayerData = createSelector(agentsTransferToPlayerDataSelector, (data) => data);
export const selectTransferToPlayerError = createSelector(agentsTransferToPlayerErrorSelector, (error) => error);
export const selectTransferToPlayerIsFetching = createSelector(agentsTransferToPlayerFetchingSelector, (isFetching) => isFetching);

//AgentProfile
const agentsAgentProfileDataSelector = (state: RootState) => state.admin.agents.agentProfile.data;
const agentsAgentProfileErrorSelector = (state: RootState) => state.admin.agents.agentProfile.error;
const agentsAgentProfileFetchingSelector = (state: RootState) => state.admin.agents.agentProfile.isFetching;

export const selectAgentProfileData = createSelector(agentsAgentProfileDataSelector, (data) => data);
export const selectAgentProfileError = createSelector(agentsAgentProfileErrorSelector, (error) => error);
export const selectAgentProfileIsFetching = createSelector(agentsAgentProfileFetchingSelector, (isFetching) => isFetching);


//UpdateAgentProfile
const agentsUpdateAgentProfileDataSelector = (state: RootState) => state.admin.agents.updateAgentProfile.data;
const agentsUpdateAgentProfileErrorSelector = (state: RootState) => state.admin.agents.updateAgentProfile.error;
const agentsUpdateAgentProfileFetchingSelector = (state: RootState) => state.admin.agents.updateAgentProfile.isFetching;

export const selectUpdateAgentProfileData = createSelector(agentsUpdateAgentProfileDataSelector, (data) => data);
export const selectUpdateAgentProfileError = createSelector(agentsUpdateAgentProfileErrorSelector, (error) => error);
export const selectUpdateAgentProfileIsFetching = createSelector(agentsUpdateAgentProfileFetchingSelector, (isFetching) => isFetching);

//PlayerProfile
const agentsPlayerProfileDataSelector = (state: RootState) => state.admin.agents.playerProfile.data;
const agentsPlayerProfileErrorSelector = (state: RootState) => state.admin.agents.playerProfile.error;
const agentsPlayerProfileFetchingSelector = (state: RootState) => state.admin.agents.playerProfile.isFetching;

export const selectPlayerProfileData = createSelector(agentsPlayerProfileDataSelector, (data) => data);
export const selectPlayerProfileError = createSelector(agentsPlayerProfileErrorSelector, (error) => error);
export const selectPlayerProfileIsFetching = createSelector(agentsPlayerProfileFetchingSelector, (isFetching) => isFetching);

//UpdateAgentRole
const agentsUpdateAgentRoleDataSelector = (state: RootState) => state.admin.agents.updateAgentRole.data;
const agentsUpdateAgentRoleErrorSelector = (state: RootState) => state.admin.agents.updateAgentRole.error;
const agentsUpdateAgentRoleFetchingSelector = (state: RootState) => state.admin.agents.updateAgentRole.isFetching;

export const selectUpdateAgentRoleData = createSelector(agentsUpdateAgentRoleDataSelector, (data) => data);
export const selectUpdateAgentRoleError = createSelector(agentsUpdateAgentRoleErrorSelector, (error) => error);
export const selectUpdateAgentRoleIsFetching = createSelector(agentsUpdateAgentRoleFetchingSelector, (isFetching) => isFetching);


//Filter Roles
const filterRolesDataSelector = (state: RootState) => state.admin.agents.filterRoles.data;
const filterRolesErrorSelector = (state: RootState) => state.admin.agents.filterRoles.error;
const filterRolesFetchingSelector = (state: RootState) => state.admin.agents.filterRoles.isFetching;

export const selectFilterRolesData = createSelector(filterRolesDataSelector, (data) => data);
export const selectFilterRolesError = createSelector(filterRolesErrorSelector, (error) => error);
export const selectFilterRolesIsFetching = createSelector(filterRolesFetchingSelector, (isFetching) => isFetching);

//Filter Roles All
const filterRolesAllDataSelector = (state: RootState) => state.admin.agents.filterRolesAll.data;
const filterRolesAllErrorSelector = (state: RootState) => state.admin.agents.filterRolesAll.error;
const filterRolesAllFetchingSelector = (state: RootState) => state.admin.agents.filterRolesAll.isFetching;

export const selectFilterRolesAllData = createSelector(filterRolesAllDataSelector, (data) => data);
export const selectFilterRolesAllError = createSelector(filterRolesAllErrorSelector, (error) => error);
export const selectFilterRolesAllIsFetching = createSelector(filterRolesAllFetchingSelector, (isFetching) => isFetching);

//Block agent
const toggleBlockAgentDataSelector = (state: RootState) => state.admin.agents.blockAgent.data;
const toggleBlockAgentErrorSelector = (state: RootState) => state.admin.agents.blockAgent.error;
const toggleBlockAgentFetchingSelector = (state: RootState) => state.admin.agents.blockAgent.isFetching;

export const selectToggleBlockAgentData = createSelector(toggleBlockAgentDataSelector, (data) => data);
export const selectToggleBlockAgentError = createSelector(toggleBlockAgentErrorSelector, (error) => error);
export const selectToggleBlockAgentIsFetching = createSelector(toggleBlockAgentFetchingSelector, (isFetching) => isFetching);

//agentNewPassword
const agentsNewPasswordDataSelector = (state: RootState) => state.admin.agents.agentNewPassword.data;
const agentsNewPasswordErrorSelector = (state: RootState) => state.admin.agents.agentNewPassword.error;
const agentsNewPasswordFetchingSelector = (state: RootState) => state.admin.agents.agentNewPassword.isFetching;

export const selectAgentNewPasswordData = createSelector(agentsNewPasswordDataSelector, (data) => data);
export const selectAgentNewPasswordError = createSelector(agentsNewPasswordErrorSelector, (error) => error);
export const selectAgentNewPasswordIsFetching = createSelector(agentsNewPasswordFetchingSelector, (isFetching) => isFetching);

//BetList filters
const betListFiltersDataSelector = (state: RootState) => state.admin.agents.betListFilters.data;
const betListFiltersErrorSelector = (state: RootState) => state.admin.agents.betListFilters.error;
const betListFiltersFetchingSelector = (state: RootState) => state.admin.agents.betListFilters.isFetching;

export const selectBetListFiltersData = createSelector(betListFiltersDataSelector, (data) => data);
export const selectBetListFiltersError = createSelector(betListFiltersErrorSelector, (error) => error);
export const selectBetListFiltersIsFetching = createSelector(betListFiltersFetchingSelector, (isFetching) => isFetching);

//Casino BetList filters
const casinoBetListFiltersDataSelector = (state: RootState) => state.admin.agents.casinoBetListFilters.data;
const casinoBetListFiltersErrorSelector = (state: RootState) => state.admin.agents.casinoBetListFilters.error;
const casinoBetListFiltersFetchingSelector = (state: RootState) => state.admin.agents.casinoBetListFilters.isFetching;

export const selectCasinoBetListFiltersData = createSelector(casinoBetListFiltersDataSelector, (data) => data);
export const selectCasinoBetListFiltersError = createSelector(casinoBetListFiltersErrorSelector, (error) => error);
export const selectCasinoBetListFiltersIsFetching = createSelector(casinoBetListFiltersFetchingSelector, (isFetching) => isFetching);

//Block player
const toggleBlockPlayerDataSelector = (state: RootState) => state.admin.agents.blockPlayer.data;
const toggleBlockPlayerErrorSelector = (state: RootState) => state.admin.agents.blockPlayer.error;
const toggleBlockPlayerFetchingSelector = (state: RootState) => state.admin.agents.blockPlayer.isFetching;

export const selectToggleBlockPlayerData = createSelector(toggleBlockPlayerDataSelector, (data) => data);
export const selectToggleBlockPlayerError = createSelector(toggleBlockPlayerErrorSelector, (error) => error);
export const selectToggleBlockPlayerIsFetching = createSelector(toggleBlockPlayerFetchingSelector, (isFetching) => isFetching);

//Player status
const playerStatusDataSelector = (state: RootState) => state.admin.agents.playerStatus.data;
const playerStatusErrorSelector = (state: RootState) => state.admin.agents.playerStatus.error;
const playerStatusFetchingSelector = (state: RootState) => state.admin.agents.playerStatus.isFetching;

export const selectPlayerStatusData = createSelector(playerStatusDataSelector, (data) => data);
export const selectPlayerStatusError = createSelector(playerStatusErrorSelector, (error) => error);
export const selectPlayerStatusIsFetching = createSelector(playerStatusFetchingSelector, (isFetching) => isFetching);

//playerewPassword
const playerNewPasswordDataSelector = (state: RootState) => state.admin.agents.playerNewPassword.data;
const playerNewPasswordErrorSelector = (state: RootState) => state.admin.agents.playerNewPassword.error;
const playerNewPasswordFetchingSelector = (state: RootState) => state.admin.agents.playerNewPassword.isFetching;

export const selectPlayerNewPasswordData = createSelector(playerNewPasswordDataSelector, (data) => data);
export const selectPlayerNewPasswordError = createSelector(playerNewPasswordErrorSelector, (error) => error);
export const selectPlayerNewPasswordIsFetching = createSelector(playerNewPasswordFetchingSelector, (isFetching) => isFetching);

//Create Player
const agentsCreatePlayerDataSelector = (state: RootState) => state.admin.agents.createPlayer.data;
const agentsCreatePlayerErrorSelector = (state: RootState) => state.admin.agents.createPlayer.error;
const agentsCreatePlayerFetchingSelector = (state: RootState) => state.admin.agents.createPlayer.isFetching;

export const selectCreatePlayerData = createSelector(agentsCreatePlayerDataSelector, (data) => data);
export const selectCreatePlayerError = createSelector(agentsCreatePlayerErrorSelector, (error) => error);
export const selectCreatePlayerIsFetching = createSelector(agentsCreatePlayerFetchingSelector, (isFetching) => isFetching);
